import { AppRoutes } from "@/constants/routes";
import { AppColors } from "@/styles/colors";
import { Button, Flex, Text } from "@chakra-ui/react"
import { PointerOff } from "lucide-react";
import { useNavigate } from "react-router-dom"


export const NoPermission = () => {
    const navigate = useNavigate();
    return (
        <Flex flexDir="column" alignItems="center" justifyContent="center" height="100vh" gap="10px">
            <PointerOff size={172} color={AppColors.GRAY_TEXT} />
            <Text fontWeight={600} fontSize="18px">No tienes permiso para visualizar esta pantalla</Text>
            <Button onClick={() => navigate(AppRoutes.HOME)} bgColor={AppColors.GREEN_PRIMARY}>
                <Text paddingX="10px">Volver al inicio</Text>
            </Button>
        </Flex>
    )
}